import { isValid, parseISO } from 'date-fns';

const isISODateValid = (date) => {
  const parsedISO = parseISO(date);
  return isValid(parsedISO);
};

export default isISODateValid;
